import { Lock, ArrowDown, AlertTriangle, LinkIcon, Smartphone, LayoutGrid } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useFadeUp } from '@/hooks/useFadeUp';

const problemIcons: Record<string, LucideIcon> = {
  lock: Lock,
  'arrow-down': ArrowDown,
  'alert-triangle': AlertTriangle,
  link: LinkIcon,
  smartphone: Smartphone,
  'layout-grid': LayoutGrid,
};

const problems = [
  {
    id: 'volet-bloque',
    icon: 'lock',
    title: 'Volet bloqué',
    description: 'Votre volet ne bouge plus du tout, coincé en position ouverte ou fermée.',
    anchor: 'volet-bloque',
  },
  {
    id: 'volet-ne-remonte-plus',
    icon: 'arrow-down',
    title: 'Volet qui ne remonte plus',
    description: 'Le volet descend mais refuse de remonter. Problème de moteur ou de fin de course.',
    anchor: 'volet-ne-remonte-plus',
  },
  {
    id: 'moteur-hs',
    icon: 'alert-triangle',
    title: 'Moteur HS',
    description: 'Le moteur fait un bruit anormal, ne répond plus ou a grillé.',
    anchor: 'moteur-hs',
  },
  {
    id: 'sangle-cassee',
    icon: 'link',
    title: 'Sangle ou manivelle cassée',
    description: 'Sangle déchirée, effilochée ou manivelle bloquée.',
    anchor: 'sangle-cassee',
  },
  {
    id: 'telecommande-hs',
    icon: 'smartphone',
    title: 'Télécommande HS',
    description: 'La télécommande ne fonctionne plus, le volet ne répond pas.',
    anchor: 'telecommande-hs',
  },
  {
    id: 'lames-abimees',
    icon: 'layout-grid',
    title: 'Lames ou tablier abîmés',
    description: 'Lames tordues, cassées ou tablier endommagé.',
    anchor: 'lames-abimees',
  },
];

export function ProblemCards() {
  const ref = useFadeUp();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div ref={ref} className="fade-up max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="section-title">Quel est votre problème ?</h2>
          <p className="section-subtitle">
            Choisissez ci-dessous le type de panne que vous rencontrez
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {problems.map((problem) => {
            const Icon = problemIcons[problem.icon];
            return (
              <Link
                key={problem.id}
                to={`/nos-prestations/#${problem.anchor}`}
                className="card group cursor-pointer border border-background-200 hover:border-accent-200"
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-primary-50 flex items-center justify-center shrink-0 group-hover:bg-accent-50 transition-colors">
                    {Icon && <Icon className="w-5 h-5 text-primary-500 group-hover:text-accent-500 transition-colors" />}
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-foreground-700 text-sm md:text-base">
                      {problem.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 mt-1">
                      {problem.description}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}